import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { useTheme, styled } from '@mui/material/styles';
import { Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../utils/formatNumber';
//
import { BaseOptionChart } from './BaseOptionChart';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 300;
const LEGEND_HEIGHT = 50;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  '& .apexcharts-canvas svg': { height: CHART_HEIGHT },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));

// ----------------------------------------------------------------------

const CHART_DATA = [20, 80, 100, 40, 130];

export default function Satisfacao() {
  const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    colors: [
      theme.palette.error.dark,
      theme.palette.error.main,
      theme.palette.warning.main,
      theme.palette.primary.light, 
      theme.palette.primary.main,
    ],
    labels: ['1 ⭐', '2 ⭐', '3 ⭐', '4 ⭐','5 ⭐'],
    stroke: { 
      colors: [
              //'#1f78b4'
              theme.palette.background.paper
              ] 
    },
    legend: { floating: true, horizontalAlign: 'center' },
    dataLabels: { 
      enabled: true, 
      fontWeight: 20,
      formatter: function (val, opt) { return opt.w.config.series[opt.seriesIndex]},
      dropShadow: { enabled: false } 
    },
    tooltip: {
      fillSeriesColor: true,
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `${seriesName}`
        }
      }
    },
    plotOptions: {
      pie: {   
        //expandOnClick: true,     
         donut: { 
           labels: {
              show: false 
            }
          } 
        }
    }
  });

  return (
    <Card>
      <CardHeader title="Análise da Satisfação Global" subheader="Auto-avaliação dos utentes nas Sessões"/>
      <ChartWrapperStyle dir="ltr">
        <ReactApexChart type="donut" series={CHART_DATA} options={chartOptions} height={255} />
      </ChartWrapperStyle>
    </Card>
  );
}
